module.exports = __webpack_public_path__ + "static/report/img/w8.c69dcec3.png";